import { eDashboardActionsObj } from "../../action-types/dashboard/IDashboardActions";
import { generateActions } from "../generateActions";

export const dashboardActions = {
    ...generateActions(eDashboardActionsObj, "DASHBOARD"),
}